"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorEligibleTiersWarningModal = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorEligibleTiersWarningModal = /** @class */ (function (_super) {
    __extends(AnnualMotorEligibleTiersWarningModal, _super);
    function AnnualMotorEligibleTiersWarningModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isTierWarningModalOpen: false
        };
        _this.toggle = _this.toggle.bind(_this);
        _this.updateModalVisibility = _this.updateModalVisibility.bind(_this);
        _this.selectedTierNotEligible = _this.selectedTierNotEligible.bind(_this);
        _this.resetSelectedCoverTier = _this.resetSelectedCoverTier.bind(_this);
        return _this;
    }
    AnnualMotorEligibleTiersWarningModal.prototype.componentDidMount = function () {
        this.resetSelectedCoverTier();
        this.updateModalVisibility();
    };
    AnnualMotorEligibleTiersWarningModal.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggle });
        var tierWarningWordingElement = this.getTierWarningWordingAsElement();
        if (this.selectedTierNotEligible() && this.state.isTierWarningModalOpen) {
            return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.isTierWarningModalOpen, toggle: this.toggle },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("div", null,
                            React.createElement("img", { className: "mr-2 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon selected" })),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Because of the changes you've made..."))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0" }, tierWarningWordingElement),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-flex" },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.toggle }, "Ok, I understand"))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualMotorEligibleTiersWarningModal.prototype.getTierWarningWordingAsElement = function () {
        var selectedTier = journey_services_1.ObjectManipulator.fetchFieldValue("coverTier", this.props.interaction);
        var selectedTierNotEligible = this.selectedTierNotEligible();
        if (!selectedTierNotEligible) {
            return React.createElement(React.Fragment, null);
        }
        var uwResults = this.props.interaction.tieredUnderwritingResult;
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        if (selectedTierNotEligible && eligibleTiers.length > 0) {
            var wording = React.createElement(React.Fragment, null);
            if (selectedTier === services_1.ALLIANZ_ESSENTIALS) {
                if (eligibleTiers.length > 1) {
                    wording = (React.createElement(React.Fragment, null,
                        React.createElement("span", null,
                            "\u2026we can\u2019t give you a quote for ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(services_1.ALLIANZ_ESSENTIALS)),
                            "."),
                        React.createElement("br", null),
                        React.createElement("span", null,
                            "Instead we\u2019ll give you a quote to upgrade to ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(services_1.ALLIANZ_SILVER)),
                            " or our ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(services_1.ALLIANZ)),
                            " cover level.")));
                }
                else {
                    wording = (React.createElement(React.Fragment, null,
                        React.createElement("span", null,
                            "\u2026we can\u2019t give you a quote for ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(services_1.ALLIANZ_ESSENTIALS)),
                            "."),
                        React.createElement("br", null),
                        React.createElement("span", null,
                            "Instead we\u2019ll give you a quote to upgrade to ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(eligibleTiers[0])),
                            " cover level.")));
                }
            }
            else if (selectedTier === services_1.ALLIANZ_SILVER || selectedTier === services_1.ALLIANZ) {
                if (eligibleTiers.length > 1) {
                    wording = (React.createElement(React.Fragment, null,
                        React.createElement("span", null,
                            "\u2026we can\u2019t give you a quote for ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(selectedTier)),
                            "."),
                        React.createElement("br", null),
                        React.createElement("span", null,
                            "Instead we\u2019ll give you a quote for our ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(eligibleTiers[0])),
                            " and ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(eligibleTiers[1])),
                            " cover levels to choose from.")));
                }
                else if (eligibleTiers.length) {
                    var declinedTiers = this.getDeclinedTiers(uwResults);
                    wording = (React.createElement(React.Fragment, null,
                        React.createElement("span", null,
                            "\u2026we can\u2019t give you a quote for ",
                            React.createElement("b", null,
                                (0, commonFunctions_1.getCoverTierWording)(declinedTiers[0]),
                                "/",
                                (0, commonFunctions_1.getCoverTierWording)(declinedTiers[1])),
                            "."),
                        React.createElement("br", null),
                        React.createElement("span", null,
                            "Instead we\u2019ll give you a quote for our ",
                            React.createElement("b", null, (0, commonFunctions_1.getCoverTierWording)(eligibleTiers[0])),
                            " cover level.")));
                }
            }
            return wording;
        }
        return React.createElement(React.Fragment, null);
    };
    AnnualMotorEligibleTiersWarningModal.prototype.toggle = function () {
        this.setState({
            isTierWarningModalOpen: !this.state.isTierWarningModalOpen
        });
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        if (eligibleTiers.length === 1) {
            journey_services_1.ObjectManipulator.setField(this.props.question.interactionField, this.props.interaction, eligibleTiers[0]);
            journey_services_1.ObjectManipulator.setField("coverTier", this.props.interaction, eligibleTiers[0]);
            this.props.onStateChange("coverTier", eligibleTiers[0]);
            this.executeEvent("change");
        }
    };
    AnnualMotorEligibleTiersWarningModal.prototype.updateModalVisibility = function () {
        if (this.selectedTierNotEligible() && !this.state.isTierWarningModalOpen) {
            this.setState({
                isTierWarningModalOpen: true
            });
        }
    };
    AnnualMotorEligibleTiersWarningModal.prototype.selectedTierNotEligible = function () {
        if (!(0, commonFunctions_1.getEligibleTiers)(this.props.interaction).includes(this.props.interaction.coverTier)) {
            return true;
        }
        return false;
    };
    AnnualMotorEligibleTiersWarningModal.prototype.getDeclinedTiers = function (uwResults) {
        return uwResults.filter(function (uw) { return uw.underwritingFailures.length > 0; }).map(function (uw) { return uw.tier; });
    };
    AnnualMotorEligibleTiersWarningModal.prototype.resetSelectedCoverTier = function () {
        if (!(0, commonFunctions_1.getEligibleTiers)(this.props.interaction).includes(this.props.interaction.uistate.selectedCoverTier)) {
            journey_services_1.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, null);
        }
    };
    return AnnualMotorEligibleTiersWarningModal;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorEligibleTiersWarningModal = AnnualMotorEligibleTiersWarningModal;
//# sourceMappingURL=AnnualMotorEligibleTiersWarningModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorEligibleTiersWarningModal.js
// module id = 3240
// module chunks = 0